import { Observable, PropertyChangedEventArgs } from "../../events";
import { IsTileDatasource } from "../tiles.interfaces";
import { IsTileMapLayerContainerProxy } from "./tiles.map.interfaces";
import { Assert } from "../../utils";
import { TileContentProvider } from "../providers";
export class TileMapLayer {
    constructor(name, provider, options, enabled) {
        Assert(name !== undefined && name !== null && name !== "", "Invalid layer name.");
        Assert(provider !== undefined && name !== null, "Invalid provider or datasource");
        this._name = name;
        this._provider = IsTileDatasource(provider) ? this._buildProvider(provider) : provider;
        this._weight = options?.weight ?? -1;
        this._zoomOffset = options?.zoomOffset ?? 0;
        this._attribution = options?.attribution;
        this._draw = options?.drawFn;
        this._drawTarget = options?.drawTarget ?? this;
        this._enabled = enabled ?? true;
    }
    get metrics() {
        return this._provider.metrics;
    }
    get provider() {
        return this._provider;
    }
    get drawFn() {
        return this._draw;
    }
    get drawTarget() {
        return this._drawTarget;
    }
    get propertyChangedObservable() {
        if (!this._propertyChangedObservable) {
            this._propertyChangedObservable = new Observable();
        }
        return this._propertyChangedObservable;
    }
    get weightChangedObservable() {
        if (!this._weightChangedObservable) {
            this._weightChangedObservable = new Observable();
        }
        return this._weightChangedObservable;
    }
    get name() {
        return this._name;
    }
    get weight() {
        return this._weight;
    }
    set weight(zindex) {
        if (this._weight !== zindex) {
            if (this._propertyChangedObservable && this._propertyChangedObservable.hasObservers()) {
                const oldValue = this._weight;
                this._weight = zindex;
                const args = new PropertyChangedEventArgs(this, oldValue, this._weight, "weight");
                this._propertyChangedObservable.notifyObservers(args, -1, this, this);
                return;
            }
            if (this._weightChangedObservable && this._weightChangedObservable.hasObservers()) {
                this._weightChangedObservable.notifyObservers(this, -1, this, this);
            }
            this._weight = zindex;
        }
    }
    get zoomOffset() {
        return this._zoomOffset ?? 0;
    }
    set zoomOffset(zoomOffset) {
        if (this._zoomOffset !== zoomOffset) {
            if (this._propertyChangedObservable && this._propertyChangedObservable.hasObservers()) {
                const oldValue = this._zoomOffset;
                this._zoomOffset = zoomOffset;
                const args = new PropertyChangedEventArgs(this, oldValue, this._zoomOffset, "zoomOffset");
                this._propertyChangedObservable.notifyObservers(args, -1, this, this);
                return;
            }
            this._zoomOffset = zoomOffset;
        }
    }
    get attribution() {
        return this._attribution;
    }
    set attribution(attribution) {
        if (this._attribution !== attribution) {
            if (this._propertyChangedObservable && this._propertyChangedObservable.hasObservers()) {
                const oldValue = this._attribution;
                this._attribution = attribution;
                const args = new PropertyChangedEventArgs(this, oldValue, this._attribution, "attribution");
                this._propertyChangedObservable.notifyObservers(args, -1, this, this);
                return;
            }
            this._attribution = attribution;
        }
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(enabled) {
        if (this._enabled !== enabled) {
            if (this._propertyChangedObservable && this._propertyChangedObservable.hasObservers()) {
                const oldValue = this._enabled;
                this._enabled = enabled;
                const args = new PropertyChangedEventArgs(this, oldValue, this._enabled, "enabled");
                this._propertyChangedObservable.notifyObservers(args, -1, this, this);
                return;
            }
            this._enabled = enabled;
        }
    }
    addTo(map) {
        if (map) {
            if (IsTileMapLayerContainerProxy(map)) {
                map = map.layers;
            }
            map?.add(this);
        }
        return this;
    }
    dispose() { }
    _buildProvider(dataSource, cache) {
        return new TileContentProvider(dataSource, cache);
    }
}
//# sourceMappingURL=tiles.map.layer.js.map